import React from 'react';
import PropTypes from 'prop-types';
import { range } from '../../../../lib/utilities';
import { Star } from './star';

export const Stars = props => {
    const fullStars = Math.floor(props.average);
    const partiallyFilledStar = props.average - fullStars;
    const emptyStars = 5 - fullStars - (partiallyFilledStar ? 1 : 0);

    return [
        ...range(fullStars).map(
            i => (
                <Star
                    key={'fullStar' + i}
                />
            )
        ),
        ...range(partiallyFilledStar ? 1 : 0).map(
            i => (
                <Star
                        fullness={partiallyFilledStar}
                    key={'partialStar' + i}
                />
            )
        ),
        ...range(emptyStars).map(
            i => (
                <Star
                    fullness={0}
                    key={'emptyStar' + i}
                />
            )
        ),
    ];
};

Stars.propTypes = {
    reviewCount: PropTypes.number.isRequired,
    average: PropTypes.number.isRequired,
};
